import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../firebase/AuthContext';

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { userProfile, sessionId } = useAuth();
  const [isProcessing, setIsProcessing] = useState(true);

  useEffect(() => {
    const stripeCheckoutSessionId = searchParams.get('session_id');
    const posterImageUrl = searchParams.get('poster_image_url');
    const posterId = searchParams.get('poster_id');

    if (stripeCheckoutSessionId) {
      if (!sessionId) {
        console.warn('PaymentSuccess: アプリのセッションがありません。プレミアム更新をスキップします。');
        setIsProcessing(false);
        setTimeout(() => {
          navigate('/top');
        }, 3000);
        return;
      }
      // バックエンドにプレミアム状態更新を通知（モック実装）
      updateUserPremiumStatus(stripeCheckoutSessionId)
        .then(() => {
          // Premium status updated successfully
          // 3秒後にポスター詳細ページに戻る
          setTimeout(() => {
            if (posterImageUrl) {
              navigate('/poster-detail', { 
                state: { 
                  posterImageUrl,
                  posterId,
                  premiumActivated: true,
                  fromPaymentSuccess: true
                }
              });
            } else {
              navigate('/top');
            }
          }, 2000);
        })
        .catch(err => {
          console.error('Premium status update failed:', err);
          // エラーでも一旦戻る（モック実装のため）
          setTimeout(() => {
            if (posterImageUrl) {
              navigate('/poster-detail', { 
                state: { 
                  posterImageUrl,
                  premiumActivated: true,
                  fromPaymentSuccess: true
                }
              });
            } else {
              navigate('/top');
            }
          }, 2000);
        });
    } else {
      // セッションIDがない場合はエラー
      setTimeout(() => {
        navigate('/top');
      }, 3000);
    }
  }, [navigate, searchParams, sessionId]);

  // モック実装：バックエンドにプレミアム状態更新を通知
  const updateUserPremiumStatus = async (stripeCheckoutSessionId) => {
    // 実際のバックエンドAPI呼び出し
    try {
      if (!sessionId) {
        throw new Error('アプリのセッションがありません');
      }
      const { updatePremiumStatus } = await import('../firebase/api');
      const result = await updatePremiumStatus(sessionId, stripeCheckoutSessionId);
      setIsProcessing(false);
      return result;
    } catch (error) {
      console.error('Premium status update failed:', error);
      // エラーでも一旦処理完了とする（モック実装のため）
      setIsProcessing(false);
      throw error;
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      backgroundColor: '#f5f5f5'
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '40px',
        borderRadius: '12px',
        boxShadow: '0 4px 24px rgba(0, 0, 0, 0.1)',
        textAlign: 'center',
        maxWidth: '400px',
        width: '100%'
      }}>
        <img 
          src="/img/cat.png" 
          alt="成功アイコン" 
          style={{ width: '80px', height: '80px', marginBottom: '20px' }}
        />
        
        <h2 style={{ color: '#4CAF50', marginBottom: '20px' }}>
          {isProcessing ? '処理中...' : '支払い完了！'}
        </h2>
        
        <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '20px' }}>
          {isProcessing 
            ? 'プレミアム機能を有効化しています...' 
            : 'プレミアム機能が有効になりました！\n7つ目のポスター、4つ目のコメントが追加できるようになります。'
          }
        </p>
        
        {!isProcessing && (
          <p style={{ color: '#999', fontSize: '0.9rem' }}>
            まもなく元のページに戻ります...
          </p>
        )}
      </div>
    </div>
  );
};

export default PaymentSuccess;
